import React from "react";
import Checkbox from "./Checkbox";
import FilterTitle from "./FilterTitle";
import ViewMore from "./ViewMore";

const CheckboxFilter = ({ title, filterData, filterName }) => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-2 py-8">
      <FilterTitle title={title} />
      <div className="mb-2 flex flex-col gap-2">
        {filterData.map((item) => (
          <Checkbox
            key={item.id}
            id={item.id}
            label={item.name}
            filterName={filterName}
            amount={item.amount}
          />
        ))}
      </div>
      <ViewMore />
    </div>
  );
};

export default CheckboxFilter;
